import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../project-constants';
import {ContractTypeModel} from '../../../models/ContractTypeModel';

@Injectable({
  providedIn: 'root'
})
export class NumAnnoMeseService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  baseUrl: string = servers.apiUrl + urls.numAnnoMeseSetting;

  getAllMonth(contractType?: ContractTypeModel): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_ALL_MONTH;
    const body = contractType;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, { headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getAllYear(contractType?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_ALL_YEAR;
    const body = contractType ? contractType : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getFirtsYear(): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_FIRST_YEAR;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, null, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getFirtsAnnoMese(): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_FIRST_MONTH;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, null, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getLastConsumptiveVolMonth(): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_LAST_CONSUMPTIVE_VOL_MONTH;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, null, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getLastConsumptiveChargeMonth(): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_LAST_CONSUMPTIVE_CHARGE_MONTH;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getConsolidateMonthByProvider(body: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_CONSOLIDATE_MONTH_BY_PROV;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getQuarter(): Observable<any> {
    const url = this.baseUrl + this.LINKS.GET_QUARTER_MONTH;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, null, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
